import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = '/configuracion/tipos-de-depositos-bancario';

/**
 * GET Tipos de Deposito Bancario
 * @returns {Promise<Array<object>>}
 */
export const getTiposDeDepositosBancarios = async () => {
  try {
    const response = await API.get(baseURI);
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Tipo de Deposito Bancario
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getTipoDeDepositoBancario = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Tipo de Deposito Bancario
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postTipoDeDepositoBancario = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Tipo de Deposito Bancario
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchTipoDeDepositoBancario = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Tipo de Deposito Bancario
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteTipoDeDepositoBancario = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
